import script from "./ValidationTwoTransfertContent.vue?vue&type=script&setup=true&lang=ts"
export * from "./ValidationTwoTransfertContent.vue?vue&type=script&setup=true&lang=ts"

import "./ValidationTwoTransfertContent.vue?vue&type=style&index=0&id=a94a907e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a94a907e"]])

export default __exports__